import { jsx as _jsx } from "react/jsx-runtime";
import AccordionExample from "./Accordion";
import AlertExample from "./Alert";
import AppBarExample from "./AppBar";
import AvatarExample from "./Avatar";
import BadgeExample from "./Badge";
import BottomNavigationExample from "./BottomNavigation";
import ButtonExample from "./Button";
import CardExample from "./Card";
import CheckboxesExample from "./Checkboxes";
import ChipExample from "./Chip";
import DateCalendarExample from "../MTCustomCompontent/DateCalendar";
import DialogExample from "./Dialog";
import FabExample from "./FAB";
import IconExample from "./Icon";
import ListExample from "./List";
import MenuExample from "./Menu";
import ProgressExample from "./Progress";
import RadioExample from "./RadioGroup";
import SelectExample from "./Select";
import SliderExample from "./Slider";
import SnackbarExample from "./Snackbar";
import StepperExample from "./Stepper";
import SwitchExample from "./Switch";
import TableExample from "./Table";
import TabsExample from "./Tabs";
import TextFieldExample from "./TextField";
import TooltipExample from "./Tooltip";
import TypographyExample from "./Typography";
// items skipped for now:
// Button Group
// Date/Time inputs
// Transfer List
// Drawer
// Alphabetically sorted list of all Material-UI component examples
export default [
    {
        id: "Accordion",
        title: "Accordion",
        component: _jsx(AccordionExample, {}),
        docs: "https://material-ui.com/components/accordion/",
    },
    {
        id: "Alert",
        title: "Alert",
        component: _jsx(AlertExample, {}),
        docs: "https://material-ui.com/components/alert/",
    },
    {
        id: "Appbar",
        title: "App Bar",
        // @ts-ignore
        component: _jsx(AppBarExample, {}),
        docs: "https://material-ui.com/components/app-bar/",
    },
    {
        id: "Avatar",
        title: "Avatar",
        component: _jsx(AvatarExample, {}),
        docs: "https://material-ui.com/components/avatars/",
    },
    {
        id: "Badge",
        title: "Badge",
        component: _jsx(BadgeExample, {}),
        docs: "https://material-ui.com/components/badges/",
    },
    {
        id: "BottomNavigation",
        title: "Bottom Navigation",
        component: _jsx(BottomNavigationExample, {}),
        docs: "https://material-ui.com/components/bottom-navigation/",
    },
    {
        id: "Buttons",
        title: "Buttons",
        component: _jsx(ButtonExample, {}),
        docs: "https://material-ui.com/components/buttons/",
    },
    {
        id: "Card",
        title: "Card",
        component: _jsx(CardExample, {}),
        docs: "https://material-ui.com/components/cards/",
    },
    {
        id: "Checkboxes",
        title: "Checkboxes",
        component: _jsx(CheckboxesExample, {}),
        docs: "https://material-ui.com/components/checkboxes/",
    },
    {
        id: "Chip",
        title: "Chip",
        component: _jsx(ChipExample, {}),
        docs: "https://material-ui.com/components/chips/",
    },
    {
        id: "DateCalendar",
        title: "Date Calendar",
        component: _jsx(DateCalendarExample, {}),
    },
    {
        id: "Dialog",
        title: "Dialog",
        component: _jsx(DialogExample, {}),
        docs: "https://material-ui.com/components/dialogs/",
    },
    {
        id: "FloatingActionButton",
        title: "Floating Action Button",
        component: _jsx(FabExample, {}),
        docs: "https://material-ui.com/components/floating-action-button/",
    },
    {
        id: "Icon",
        title: "Icon",
        component: _jsx(IconExample, {}),
        docs: "https://material-ui.com/components/icons/",
    },
    {
        id: "List",
        title: "List",
        component: _jsx(ListExample, {}),
        docs: "https://material-ui.com/components/lists/",
    },
    {
        id: "Menu",
        title: "Menu",
        component: _jsx(MenuExample, {}),
        docs: "https://material-ui.com/components/menus/",
    },
    {
        id: "Progress",
        title: "Progress",
        component: _jsx(ProgressExample, {}),
        docs: "https://material-ui.com/components/progress/",
    },
    {
        id: "Radio",
        title: "Radio",
        component: _jsx(RadioExample, {}),
        docs: "https://material-ui.com/components/radio-buttons/",
    },
    {
        id: "Select",
        title: "Select",
        component: _jsx(SelectExample, {}),
        docs: "https://material-ui.com/components/selects/",
    },
    {
        id: "Slider",
        title: "Slider",
        component: _jsx(SliderExample, {}),
        docs: "https://material-ui.com/components/slider/",
    },
    {
        id: "Snackbar",
        title: "Snackbar",
        component: _jsx(SnackbarExample, {}),
        docs: "https://material-ui.com/components/snackbars/",
    },
    {
        id: "Stepper",
        title: "Stepper",
        component: _jsx(StepperExample, {}),
        docs: "https://material-ui.com/components/steppers/",
    },
    {
        id: "Switch",
        title: "Switch",
        component: _jsx(SwitchExample, {}),
        docs: "https://material-ui.com/components/switches/",
    },
    {
        id: "Table",
        title: "Table",
        component: _jsx(TableExample, {}),
        docs: "https://material-ui.com/components/tables/",
    },
    {
        id: "Tabs",
        title: "Tabs",
        component: _jsx(TabsExample, {}),
        docs: "https://material-ui.com/components/tabs/",
    },
    {
        id: "TextField",
        title: "TextField",
        component: _jsx(TextFieldExample, {}),
        docs: "https://material-ui.com/components/text-fields/",
    },
    {
        id: "Tooltip",
        title: "Tooltip",
        component: _jsx(TooltipExample, {}),
        docs: "https://material-ui.com/components/tooltips/",
    },
    {
        id: "Typography",
        title: "Typography",
        component: _jsx(TypographyExample, {}),
        docs: "https://material-ui.com/components/typography/",
    },
];
